import React from 'react';
import { Nav } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { faList } from '@fortawesome/free-solid-svg-icons';

// Import the SVG icons
import logo from "@/assets/images/unionIcon.svg";
import home from "@/assets/images/home.svg";
import calendar from "@/assets/images/calendar.svg";
import todos from "@/assets/images/todos.svg";
import feed from "@/assets/images/feed.svg";
import head from "@/assets/images/robothead.svg";
import gear from "@/assets/images/gear.svg";

const MobileNavbar = ({ onNavItemClick, activeItem }) => {
    const location = useLocation();

    const navItems = [
        { id: 'home', icon: home, label: 'Home', alt: 'Home' },
        { id: 'calendar', icon: calendar, label: 'Calendar', alt: 'Calendar', fontAwesomeIcon: 'calendar' },
        { id: 'feed', icon: feed, label: 'Feed', alt: 'Feed', fontAwesomeIcon: 'newspaper' },
        { id: 'memory', icon: head, label: "Ian's Memory", alt: "Ian's Memory" },
        { id: 'todos', icon: todos, label: "To Do's", alt: "To Do's", fontAwesomeIcon: 'list' },
        { id: 'settings', icon: gear, label: 'Settings', alt: 'Settings' }
    ];

    return (
        <div className="mobile-navbar d-md-none">
            <Nav className="justify-content-between w-100 px-2">
                {navItems.map(item => (
                    <Nav.Item key={item.id} className="text-center">
                        <Nav.Link
                            onClick={() => onNavItemClick(item.id)}
                            className={`mobile-nav-link ${activeItem === item.id ? 'active' : ''}`}
                        >
                            {item.icon ? (
                                <img
                                    src={item.icon}
                                    alt={item.alt}
                                    className="mobile-nav-icon"
                                    style={{ maxWidth: '24px', height: '20px' }}
                                />
                            ) : (
                                <FontAwesomeIcon
                                    icon={item.fontAwesomeIcon}
                                    size="lg"
                                    className="mobile-nav-icon"
                                />
                            )}
                            <div className="mobile-nav-label">{item.label}</div>
                        </Nav.Link>
                    </Nav.Item>
                ))}
            </Nav>
        </div>
    );
};

export default MobileNavbar;